import React from "react";
import { Button, Card, CardActions, CardContent, Typography } from "@mui/material";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { formatSupplierSubtitle, normalizeInput } from "./supplierUtils";

const SupplierCard = ({ supplier, onEdit, onDelete }) => (
    <Card
        sx={{
            borderRadius: 3,
            border: (theme) =>
                `1px solid ${theme.palette.mode === "dark" ? theme.palette.divider : "#ffe0b2"}`,
            boxShadow: (theme) =>
                theme.palette.mode === "dark" ? "0 6px 24px rgba(0,0,0,0.45)" : "0 6px 24px rgba(0,0,0,0.06)",
            background: (theme) =>
                theme.palette.mode === "dark"
                    ? theme.palette.background.paper
                    : "linear-gradient(0deg, #fff8e1 0%, #fff 60%)",
            height: "100%",
            display: "flex",
            flexDirection: "column",
        }}
    >
        <CardContent sx={{ flexGrow: 1 }}>
            <Typography variant="subtitle1" fontWeight={700}>
                {supplier.name || "Unbenannter Lieferant"}
            </Typography>
            {formatSupplierSubtitle(supplier) && (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                    {formatSupplierSubtitle(supplier)}
                </Typography>
            )}
            {normalizeInput(supplier.notes) && (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1, whiteSpace: "pre-wrap" }}>
                    {supplier.notes}
                </Typography>
            )}
        </CardContent>
        <CardActions sx={{ pt: 0, pb: 2, px: 2, gap: 1 }}>
            <Button size="small" startIcon={<EditRoundedIcon />} onClick={() => onEdit(supplier)}>
                Bearbeiten
            </Button>
            <Button size="small" color="error" startIcon={<DeleteRoundedIcon />} onClick={() => onDelete(supplier)}>
                Löschen
            </Button>
        </CardActions>
    </Card>
);

export default SupplierCard;
